import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomTemplatePreview, CustomTemplateReq, FavTemplateRequest, PromptResponse, SubscriptionDetails, TemplateDetail, TemplateListing } from '../../models/manage-template.interface';
import { API_ROUTES } from '../../util/route.constants';

@Injectable({
  providedIn: 'root'
})
export class CustomTemplateService {
  constructor(private readonly  http: HttpClient,) { }

  getData(sortBy = 'createdBy'): Observable<{ response: TemplateListing[] }> {
    const url = environment.cva_url + API_ROUTES.CUSTOM_TEMPLATE;
    return this.http.get<{ response: TemplateListing[] }>(url + `?sortBy=${sortBy}`);
  }

  save(payload: CustomTemplateReq): Observable<{ response: boolean }> {
    return this.http.post<{ response: boolean }>(
      environment.cva_url + API_ROUTES.CUSTOM_TEMPLATE,
      payload
    );
  }

  getById(identifier: string): Observable<{ response: TemplateDetail }> {
    const url = environment.cva_url + API_ROUTES.CUSTOM_TEMPLATE;
    return this.http.get<{ response: TemplateDetail }>(url + '/' + identifier);
  }

  update(identifier: string, payload: CustomTemplateReq): Observable<{ response: boolean }> {
    return this.http.patch<{ response: boolean }>(
      `${environment.cva_url}${API_ROUTES.CUSTOM_TEMPLATE}/${identifier}`,
      payload
    )
  }

  deleteById(identifier: string): Observable<{ response: TemplateListing[] }> {
    const url = environment.cva_url + API_ROUTES.CUSTOM_TEMPLATE;
    return this.http.delete<{ response: TemplateListing[] }>(url + '/' + identifier);
  }

  generateTemplate(formData: FormData): Observable<{ response: PromptResponse }> {
    const url = environment.cva_url + API_ROUTES.CUSTOM_TEMPLATE + API_ROUTES.GENERATE;
    return this.http.post<{ response: PromptResponse }>(url, formData);
  }

  getSubscriptionDetails():Observable< {success:true,data:SubscriptionDetails}>{
    return this.http.get<{success:true,data:SubscriptionDetails}>(`${environment.user_management_api_url}/${API_ROUTES.SUBSCRIPTION_DETAILS}`)
  }

  markOrUnMarkFavoriteTemplate(payload: FavTemplateRequest): Observable<{ response: boolean }> {
    return this.http.patch<{ response: boolean }>(
      `${environment.cva_url}${API_ROUTES.USER_FAV_TEMPLATE}${API_ROUTES.TOGGLE_TEMPLATE_FAV_STATUS}`,
      payload
    )
  }

  generatePreview(payload: CustomTemplatePreview): Observable<{ response: string }> {
    return this.http.post<{ response: string }>(
      `${environment.cva_url}${API_ROUTES.CUSTOM_TEMPLATE}${API_ROUTES.GENERATE_PREVIEW}`,
      payload
    )
  }

    getTemplateContentByTeamOrSelf(identifier: string): Observable<{ response: string }> {
    const url = environment.cva_url + API_ROUTES.CUSTOM_TEMPLATE + API_ROUTES.CONTENT;
    return this.http.post<{ response: string }>(url + '/' + identifier, {});
  }


}
